<template>
  <kst-section class="kstmod-moduleattr-relatedglobalinput" :title="title">
    <List :items="items"/>
  </kst-section>
</template>

<script>
import Info from "../ModuleAttrInfo.js";
import Model from "../ModuleAttrModel.js";

import List from "./MattReGI_List.vue";

export default {
  components: {
    List
  },
  props: {
    moduleAttrList: Array
  },
  data: () => ({
    items: []
  }),
  computed: {
    title() {
      return Info.Section.Global.Title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.items = [];

      for (const moduleAttr of this.moduleAttrList) {
        if (moduleAttr.TypeID === Model.Type.Global.ID) {
          this.items.push(moduleAttr);
        }
      }
    }
  }
}
</script>